import dayjs from 'dayjs';

export function DateTimeChecker(startDateTime, endDateTime) {
  return dayjs(startDateTime) < dayjs(endDateTime);
}
